export interface IEstabLeito {
    id: string;
    idTipo: string;
    tipo: string;
    codigoLeito: string;
    detalhamento: string;
    quantidadeAtivo: number;
    quantidadeNoSus: number;
    quantidadeHabilitados: number;
    leitoObj: any;
    competenciaFinal: string;
    competenciaInicial: string;
}

export class EstabLeitoModel {
    id: string;
    idTipo: string;
    tipo: string;
    codigoLeito: string;
    detalhamento: string;
    quantidadeAtivo: number;
    quantidadeNoSus: number;
    quantidadeHabilitados: number;
    leitoObj: any;
    competenciaFinal: string;
    competenciaInicial: string;

    constructor(obj: IEstabLeito) {
        this.id = obj.id ? obj.id : '';
        this.idTipo = obj.idTipo ? obj.idTipo : '';
        this.tipo = obj.tipo ? obj.tipo : '';
        this.codigoLeito = obj.codigoLeito ? obj.codigoLeito : '';
        this.detalhamento = obj.detalhamento ? obj.detalhamento : '';
        this.quantidadeAtivo = obj.quantidadeAtivo ? obj.quantidadeAtivo : 0;
        this.quantidadeNoSus = obj.quantidadeNoSus ? obj.quantidadeNoSus : 0;
        this.quantidadeHabilitados = obj.quantidadeHabilitados ? obj.quantidadeHabilitados : 0;
        this.leitoObj = obj.leitoObj ? obj.leitoObj : {};
        this.competenciaFinal = obj.competenciaFinal ? obj.competenciaFinal : '';
        this.competenciaInicial = obj.competenciaInicial ? obj.competenciaInicial : '';
    }
}
